<template>
	<div class="container" id="topTarget" @scroll="goscroll">
		<div class="title" style="display: flex;">
			<div>
				<!-- <span @click="go" style="margin-left: 20px;">返回</span> -->
				<!-- <el-divider direction="vertical"></el-divider> -->
			</div>
			<div style="display: flex;align-items: center;justify-content: center;flex:1;">
				{{ pageTile }}入库单
			</div>
		</div>
		
		<div style="padding: 30px;">
			<el-form v-model="storelinks">
				<div style="display: flex;">
                    <!-- <el-form-item label="开单日期:" label-width="120px" >
						<el-date-picker value-format="yyyy-MM-dd" style="width: 220px;" v-model="storelinks.sendDate" placeholder="选择开单日期:">
						</el-date-picker>
					</el-form-item> -->
                    <el-form-item label="仓库" label-width="120px">
						<el-select filterable v-model="storelinks.warehouseId" style="width: 220px" placeholder="请选择" clear 
						@change="warehouseChange">
                        <!-- :remote-method="WarehouseLis" remote allow-create learable -->
							<el-option v-for="it in entrepotList" :key="it.id" :value="it.id" :label="it.warehouseName"></el-option>
						</el-select>
					</el-form-item>
                    <el-form-item label-width="120px" label="订单类型:">
						<el-select filterable v-model="storelinks.orderType" placeholder="请选择" clear 
						style="width: 220px" @change="orderTypeChange">
							<el-option v-for="it in typeList" :key="it.id" :value="it.typeKey"
								:label="it.typeName"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label-width="120px" label="客户:">
						<el-select filterable v-model="storelinks.customerId"  placeholder="请选择" clear 
                        @change="customerSelect"
                        style="width: 220px">
							<el-option v-for="it in userList" :key="it.id" :value="it.id"
								:label="it.customerName"></el-option>
						</el-select>
					</el-form-item>
                    <el-form-item label="入库单号:" label-width="120px">
						<el-input type="text" style="width: 220px; " placeholder="请输入入库单号"  v-model="storelinks.orderCode"
							auto-complete="off" disabled/>
					</el-form-item>
					
				</div>
                <div style="display: flex;">
                   
                    <el-form-item label="供货单位:" label-width="120px">
						<el-input type="text" style="width: 220px; " placeholder="供货单位"  v-model="storelinks.csource"
							auto-complete="off" />
					</el-form-item>
                    <el-form-item label="客户订单号:" label-width="120px">
						<el-input type="text" style="width: 220px; " placeholder="客户订单号"  v-model="storelinks.customerOrderCode"
							auto-complete="off" />
					</el-form-item>
                    <el-form-item label="车牌号码:" label-width="120px">
						<el-input type="text" style="width: 220px; " placeholder="车牌号码"  v-model="storelinks.carNo"
							auto-complete="off" />
					</el-form-item>
					<el-form-item label="状态:" label-width="120px">
						<span v-if="storelinks.status==0" style="color:#409EFF;font-weight: bold;">制单中</span>
						<span v-if="storelinks.status==1" style="color:#F7BA2A;font-weight: bold;">入库中</span>
						<span v-if="storelinks.status==2" style="color:#13CE66;font-weight: bold;">已完成</span>
					</el-form-item>
                </div>
				
				<div style="justify-content: space-between;display: flex;align-items: center;margin-right: 20px;">
					<div style="display: flex;" >
						<el-form-item label="入库日期:" label-width="120px">
							<el-date-picker 
								v-model="storelinks.storageTime" value-format="yyyy-MM-dd"
								 type="date" 
								placeholder="选择日期"> 
								<!-- value-format="yyyy-MM-dd" -->
							</el-date-picker>
						</el-form-item>
						<el-form-item label="备注:" label-width="120px">
							<el-input type="text" style="width: 560px; " placeholder="请输入备注"  v-model="storelinks.memo"
								auto-complete="off" />
						</el-form-item>   
					</div>
					<!-- <el-button type="primary"  @click="printClick" v-if="this.orderID" >打印</el-button> -->
					<div >
						<el-button type="primary" v-print="printObj" ref="printBtn" v-if="this.orderID">打印</el-button>
					</div>
				</div>
                <div style="display: flex;">
                    <!-- <el-form-item label="总体积(m³):" label-width="120px">
						<el-input type="text" style="width: 220px; " placeholder="请输入总体积"  v-model="storelinks.volume"
							auto-complete="off" />
					</el-form-item>
                    <el-form-item label="总重量(kg):" label-width="120px">
						<el-input type="text" style="width: 220px; " placeholder="请输入总重量"  v-model="storelinks.weight"
							auto-complete="off" />
					</el-form-item> -->
					 
                </div>
				
				<div style="width: 100%;position: relative;">
					<div style="justify-content: space-between;display: flex;">
						<div style="color: #606266;padding-bottom:10px;width:40%">入库商品</div>
						<div v-if="storelinks.printTimes!=0" style="padding-right:20px;width:60%;text-align: right;">
							<span>打印次数:</span>
							<span style="padding-left:5px;">{{storelinks.printTimes}}</span>
							<span>次</span>
							<span style="padding-left:20px;">打印时间:</span>	
							<span style="padding-left:5px;">{{storelinks.lastPrintDatetime}}</span>
						</div>
					</div>
					
					<el-form-item prop="remark" >
						<div style="width: 100%;display: flex;">
							<!-- 左边 -->
							<div style="width: 40%;" >
								<el-table :data="dataList" size="mini" style="width: 100%;"  height="350"
								@row-click="handleRowClick" current-row-key="index">
									<el-table-column prop="pdtCode" label="商品编号" min-width="180" align="center" >
										<template slot-scope="scope">
											<el-select  :remote-method="input" :id="'sel'+scope.$index"  
											filterable  v-model="scope.row.pdtCode" 
											remote
												@keyup.enter.native="asd(scope.$index,$event)"
												:disabled="storelinks.status==1?true:false"
												@change="change"
												allow-create
												clearable 
												placeholder="请选择" >
												<div style="display: flex;justify-content: space-between;padding: 0 20px;font-size: 14px;">
													<span>  商品名称</span>
													商品编号
												</div>
												<el-option
													@click.native="select(scope.$index,item,index)" 
													v-for="(item,index) in goodsDataList"
													:key="item.id"
													:label="item.pdtCode"
													:value="index">
													<span style="float: left">{{ item.pdtName }}</span>
													<span style="float: right; color: #8492a6; font-size: 13px">{{ item.pdtCode }}</span>
												</el-option>
											</el-select>
										</template>
									</el-table-column>

									<el-table-column prop="goodsStatus" width="130" label="商品状态"  align="center">
										<template slot-scope="scope">
											<el-select filterable clearable v-model="scope.row.goodsStatus" 
											placeholder="请选择" 
											:disabled="storelinks.status==1?true:false">
												<el-option v-for="it in stateOfGoodsList" :key="it.id" :value="it.typeKey" :label="it.typeName"></el-option>
											</el-select>
										</template>
									
									</el-table-column>

									<el-table-column prop="batchNo" width="130" label="批次"  align="center">
										<template slot-scope="scope">
											<el-input  @blur="inputBlur(scope.$index,scope.row,'batchNo')" 
											@keyup.enter.native="keydown(scope.$index,scope.row,'batchNo')"
											:disabled="storelinks.status==1?true:false"
											v-model.trim="scope.row.batchNo" placeholder="请输入批次" clearable>
											</el-input>
										</template>
									</el-table-column>
									<el-table-column prop="num" width="90" label="计划数"  align="center">
										<template slot-scope="scope">
											<el-input  @blur="inputBlur(scope.$index,scope.row,'num')" 
											@input="inputInput(scope.$index,scope.row,'num')"
											@keyup.enter.native="keydown(scope.$index,scope.row, 'num')"
											:disabled="storelinks.status==1?true:false"
											v-model.trim="scope.row.num" placeholder="请输入计划数" clearable>
											</el-input>
										</template>
									</el-table-column>
									<el-table-column prop="eaNum" label="计划数EA" align="center" width="90">
										<template slot-scope="scope">
											<el-input @keyup.enter.native="keydown(scope.$index,scope.row, 'eaNum')" 
											@input="inputInput(scope.$index,scope.row,'eaNum')"
											@blur="inputBlur(scope.$index,scope.row,'eaNum')"
											:disabled="storelinks.status==1?true:false"
											v-model.trim="scope.row.eaNum" placeholder="请输入计划数EA" clearable>
											</el-input>
										</template>
									</el-table-column>
									<el-table-column prop="pdtName" width="200" label="商品名称" align="center"
										class-name="small-padding ">
									</el-table-column>
									<!-- <el-table-column prop="qtyReceived" label="实收" align="center" 
									:show-overflow-tooltip="true" width="120">
										<template slot-scope="scope">
											<el-input @keyup.enter.native="keydown(scope.$index,scope.row, 'qtyReceived')" 
											@blur="inputBlur(scope.$index,scope.row,'qtyReceived')"
											v-model.trim="scope.row.qtyReceived" placeholder="请输入实收" clearable>
											</el-input>
										</template>
									</el-table-column>
									<el-table-column prop="eaQtyReceived" label="实收EA" align="center" 
									:show-overflow-tooltip="true" width="120">
										<template slot-scope="scope">
											<el-input @keyup.enter.native="keydown(scope.$index,scope.row, 'eaQtyReceived')" 
											@blur="inputBlur(scope.$index,scope.row,'eaQtyReceived')"
											v-model.trim="scope.row.eaQtyReceived" placeholder="请输入实收" clearable>
											</el-input>
										</template>
									</el-table-column> -->
									<!-- <el-table-column prop="warehouseLocationId" label="库位" align="center" 
									:show-overflow-tooltip="true" width="150">
										<template slot-scope="scope">
											<el-select filterable clearable v-model="scope.row.warehouseLocationId" 
												placeholder="请选择"  :remote-method="districtFocus"  
											remote
												@keyup.enter.native="kuwei(scope.$index,$event)"
												allow-create>
											<el-option v-for="it in locationList" :key="it.id" :value="it.id" 
											:label="it.warehouseLocationName" @click.native="kuweiSelect(scope.$index,item,index)" ></el-option>
											</el-select>
										</template>
									</el-table-column> -->
									<!-- <el-table-column prop="remark" width="200" label="备注"  align="center">
										<template slot-scope="scope">
											<el-input  @blur="inputBlur(scope.$index,scope.row,'remark')" 
											@keyup.enter.native="keydown(scope.$index,scope.row, 'remark')" 
											v-model.trim="scope.row.remark" placeholder="请输入备注" clearable>
											</el-input>
										</template>
									</el-table-column> -->
									<el-table-column width="80" label="操作" fixed="right" align="center"
										class-name="small-padding fixed-width">
										<template slot-scope="scope">
											<el-button type="text" icon="el-icon-delete"
												@click="handleDelete(scope.$index, scope.row)"></el-button>
												<el-button v-if="aid==scope.row.id"  type="text" 
													@click="tableBC(scope.$index, scope.row)">保存</el-button>
										</template>
									</el-table-column>
								</el-table>
							</div>

							<!-- 右边 -->
							<div style="width: 60%;">
								<!-- <el-button type="primary" @click="addCarousel">新增</el-button> -->
								<el-table :data="rightDataList" size="mini" height="350" 
								@row-click="handleRowClickRight" class="styleTable"
								current-row-key="index">
									<el-table-column prop="pdtCode" label="商品编号" width="160" align="center" >
									</el-table-column>
									<el-table-column prop="goodsStatusName" width="70" label="商品状态"  align="center">
									</el-table-column>
									<el-table-column prop="batchNo" width="80" label="批次"  align="center">
									</el-table-column>
									<el-table-column prop="num" width="100" label="计划数"  align="center">
										<template slot-scope="scope">
											<el-input  @blur="inputBlurRight(scope.$index,scope.row,'num')" 
											@input="inputInputRight(scope.$index,scope.row,'num')"
											@keyup.enter.native="keydownRigt(scope.$index,scope.row, 'num')"
											v-model.trim="scope.row.num" placeholder="计划数" clearable>
											</el-input>
										</template>
									</el-table-column>
									
									<el-table-column prop="eaNum" width="100" label="计划数EA"  align="center">
										<template slot-scope="scope">
											<el-input  @blur="inputBlurRight(scope.$index,scope.row,'eaNum')" 
											@input="inputInputRight(scope.$index,scope.row,'eaNum')"
											@keyup.enter.native="keydownRigt(scope.$index,scope.row,'eaNum')"
											v-model.trim="scope.row.eaNum" placeholder="计划数EA" clearable>
											</el-input>
										</template>
									</el-table-column>
									<el-table-column prop="warehouseLocationId" label="库位" align="center" 
									:show-overflow-tooltip="true" width="120">
										<template slot-scope="scope">
											<el-select filterable clearable v-model="scope.row.warehouseLocationId" 
												placeholder="请选择"  :remote-method="districtFocus"  
												remote 
												@keyup.enter.native="kuweiRight(scope.$index,$event)"
												allow-create>
												<!-- @blur="inputBlurRight(scope.$index,scope.row,'warehouseLocationId')" -->
											<el-option v-for="it in locationList" :key="it.id" :value="it.id" 
											:label="it.warehouseLocationName" @click.native="kuweiSelectRight(scope.$index,it,scope.row)" ></el-option>
											</el-select>
										</template>
									</el-table-column>
									<el-table-column prop="qtyReceived" width="120" label="实收数"  align="center">
										<template slot-scope="scope">
											<el-input  @blur="inputBlurRight(scope.$index,scope.row,'qtyReceived')" :id="'selRight'+scope.$index"  
											@input="inputInputRight(scope.$index,scope.row,'qtyReceived')"
											@keyup.enter.native="keydownRigt(scope.$index,scope.row,'qtyReceived')"
											v-model.trim="scope.row.qtyReceived" placeholder="实收数" clearable>
											</el-input>
										</template>
									</el-table-column>
									<el-table-column prop="eaQtyReceived" width="120" label="实收数EA"  align="center">
										<template slot-scope="scope">
											<el-input  @blur="inputBlurRight(scope.$index,scope.row,'eaQtyReceived')" 
											@input="inputInputRight(scope.$index,scope.row,'eaQtyReceived')"
											@keyup.enter.native="keydownRigt(scope.$index,scope.row,'eaQtyReceived')"
											v-model.trim="scope.row.eaQtyReceived" placeholder="实收数EA" clearable>
											</el-input>
										</template>
									</el-table-column>
									
									<!-- <el-table-column prop="remark" width="120" label="备注"  align="center">
										<template slot-scope="scope">
											<el-input  @blur="inputBlurRight(scope.$index,scope.row,'remark')" 
											@keyup.enter.native="keydownRigt(scope.$index,scope.row, 'remark')" 
											v-model.trim="scope.row.remark" placeholder="请输入备注" clearable>
											</el-input>
										</template>
									</el-table-column> -->
									
									
									<el-table-column  width="120" label="操作" fixed="right" align="center"
										class-name="small-padding fixed-width">
										<template slot-scope="scope">
											<!-- <el-button  type="danger" icon="el-icon-delete" circle
												@click="handleDeleteRight(scope.$index, scope.row)"></el-button> -->
											<el-button  type="text" icon="el-icon-delete"
												@click="handleDeleteRight(scope.$index, scope.row)"></el-button>

											<!-- <el-button type="primary" icon="el-icon-plus" circle
												v-if="scope.$index==rightDataList.length-1" @click="addCarousel()"></el-button> -->
											<el-button type="text" icon="el-icon-plus" 
												v-if="scope.$index==rightDataList.length-1" @click="addCarousel()"></el-button>

											<el-button v-if="aidRight==scope.row.id"  type="text" 
												@click="tableBCRight(scope.$index, scope.row)">保存</el-button>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</div>
						<!-- <div v-if="TableType==2">
							<el-table :data="dataList" size="mini" style="width: 100%;"  height="600"
							@row-click="handleRowClick" current-row-key="index">
								<el-table-column prop="pdtCode" label="商品编号" min-width="200" align="center" >
								</el-table-column>
								
								<el-table-column prop="pdtName" width="200" label="商品名称" align="center"
									class-name="small-padding ">
								</el-table-column>

								<el-table-column prop="oodsStatusName" width="140" label="商品状态"  align="center">
								</el-table-column>

								<el-table-column prop="batchNo" width="140" label="批次"  align="center">
								</el-table-column>
								<el-table-column prop="num" width="120" label="计划数"  align="center">
								</el-table-column>
								<el-table-column prop="eaNum" label="计划数EA" align="center" :show-overflow-tooltip="true" 
								width="120">
								</el-table-column>
								<el-table-column prop="qtyReceived" label="实收" align="center" 
								:show-overflow-tooltip="true" width="120">
								</el-table-column>
								<el-table-column prop="eaQtyReceived" label="实收EA" align="center" 
								:show-overflow-tooltip="true" width="120">
								</el-table-column>
								<el-table-column prop="warehouseLocationId" label="库位" align="center" 
								:show-overflow-tooltip="true" width="150">
								</el-table-column>
								<el-table-column prop="remark" width="200" label="备注"  align="center">
								</el-table-column>
							</el-table>
						</div> -->
					</el-form-item>
					

				</div>
				<div style="float: right;">
					<el-button type="primary" v-if="storelinks.status==0" style="float: left;margin-right: 100px;" @click="toBlockUp">入库中</el-button>
					<el-button type="primary" v-if="storelinks.status==1" style="float: left;margin-right: 100px;" @click="toStartUsing">关单</el-button>

					<el-button type="primary"  v-if="storelinks.status!=2" style="margin-right: 50px;"
                 	@click="submitClick">保存</el-button>

					
					<!-- <el-button type="primary" v-print="printObj" ref="printBtn" style="display:none">打印</el-button> -->

					<!-- <el-button
						type="primary"
						icon="el-icon-printer"
						@click="printDeliver()"
						>打印
					</el-button> -->
				</div>

               
                <!-- @click="dialogVisible" -->

				<div style="display: flex;">
					<el-form-item label="制单人:" label-width="120px">
						<el-input type="text" style="width: 220px; " placeholder="请输入制单人"  v-model="storelinks.createBy" disabled
							auto-complete="off" />
					</el-form-item>
					<el-form-item label="收货人:" label-width="120px">
						<el-input type="text" style="width: 220px; " placeholder="请输入收货人"  v-model="storelinks.receiver"
							auto-complete="off" />
					</el-form-item>
					<el-form-item label="装卸组:" label-width="120px">
						<el-input type="text" style="width: 220px; " placeholder="请输入装卸组"  v-model="storelinks.stevedore"
							auto-complete="off" />
					</el-form-item>
					
				</div>
				<div style="display: flex;">
					<el-form-item label="作业开始时间:" label-width="120px">
						<el-date-picker
                            v-model="storelinks.beginDatetime"
                            type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期时间"> 
                        </el-date-picker>
					</el-form-item>
					<el-form-item label="作业结束时间:" label-width="120px">
						<el-date-picker
							v-model="storelinks.endDatetime"
							type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
							placeholder="选择日期时间">
						</el-date-picker>
					</el-form-item>
				</div>
			</el-form>
		</div>

		<el-dialog :visible.sync="dialogVisibleSwiper" title="新增商品库位计划" @close="addDialogClose"
		:close-on-click-modal="false" width="820px">
			<div style="text-align: center;">
				<el-form :model="popupInfo">
					<el-form-item label-width="120px"  label="选择商品">
						<el-select filterable v-model="popupInfo.selectID" style="width: 300px" 
						placeholder="请选择" clear @change="popupGoodCodeChange">
							<div style="display: flex;padding: 0 20px;padding-bottom:10px;font-size: 14px;">
								
								<span style="width:150px;display: inline-block;">商品编号</span>
								<span style="width:80px;display: inline-block;">商品状态</span>
								<span style="width:80px;display: inline-block;">批次</span>
								<span style="padding-left:30px;display: inline-block;">商品名称</span>
							</div>
							<el-option v-for="item in popupGoodCodeList" :key="item.id" :label="item.pdtCode" :value="item.id">
								<span style="width:150px; color: #8492a6; font-size: 13px;display: inline-block;">{{ item.pdtCode }}</span>
								<span style="width:80px; color: #20A0FF; font-size: 13px;display: inline-block;">{{ item.goodsStatusName }}</span>
								<span style="width:80px; color: #20A0FF; font-size: 13px;display: inline-block;">{{ item.batchNo }}</span>
								<span style="padding-left:30px;display: inline-block;">{{ item.pdtName }}</span>
							</el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label-width="120px"  label="商品状态">
						<el-select filterable v-model="popupInfo.goodsStatus" style="width: 300px" placeholder="请选择" clear >
							<el-option v-for="it in popupGoodStatusList" :key="it.id" :value="it.goodsStatus" :label="it.goodsStatusName"></el-option>
						</el-select>
					</el-form-item> -->
					<!-- <el-form-item label-width="120px"  label="批次">
						<el-input  v-model="popupInfo.batchNo" placeholder="请输入批次" clearable style="width: 300px"
						></el-input>
					</el-form-item> -->
					<el-form-item label-width="120px"  label="计划数">
						<el-input  v-model="popupInfo.num" placeholder="请输入计划数" clearable style="width: 300px"
						@input="popupNumBlur"></el-input>
					</el-form-item>
					<el-form-item label-width="120px"  label="计划数EA">
						<el-input  v-model="popupInfo.eaNum" placeholder="请输入计划数EA" clearable style="width: 300px"></el-input>
					</el-form-item>
					<el-form-item label-width="120px"  label="库位">
						<el-select filterable clearable v-model="popupInfo.warehouseLocationId" 
							placeholder="请选择"  style="width: 300px"
							remote
							allow-create>
						<el-option v-for="it in locationList" :key="it.id" :value="it.id" 
						:label="it.warehouseLocationName" ></el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label-width="120px"  label="实收数">
						<el-input  v-model="popupInfo.qtyReceived" placeholder="请输入实收数" clearable style="width: 300px"></el-input>
					</el-form-item>
					<el-form-item label-width="120px"  label="实收数EA">
						<el-input  v-model="popupInfo.eaeaQtyReceivedNum" placeholder="请输入实收数EA" clearable style="width: 300px"></el-input>
					</el-form-item> -->
					<!-- <el-form-item label-width="120px"  label="备注">
						<el-input  v-model="popupInfo.remark" placeholder="请输入备注" clearable style="width: 300px"></el-input>
					</el-form-item> -->
				</el-form>
				<el-button @click="dialogVisibleSwiper=false">关闭</el-button>
				<el-button type="primary" @click="popupSubmit" :loading="popupSLoading">提交</el-button>
				
			</div>
		</el-dialog>
		
		<!-- 打印    -->
		<!-- <printModal ref="printModal" style="display:none"></printModal> -->

		<div class="printBox">
			<div id="printMe" ref="printContent" class="content">
				<div style="display: flex;align-items: center;justify-content: center;">
					入库单通知单
				</div>
				<div style="height:10px;"></div>
				<el-form v-model="printInfo">
					<div style="display: flex;justify-content: space-between;height:30px;">
						<el-form-item label="仓库:" style="width: 25%;">
							<span>{{printInfo.warehouseName}}</span>
						</el-form-item>
						<el-form-item  label="订单类型:" style="width: 25%;">
							<span>{{printInfo.orderTypeName}}</span>
						</el-form-item>
						<el-form-item label="客户:" style="width: 25%;">
							<span>{{printInfo.customerName}}</span>
						</el-form-item>
						<el-form-item label="入库单号:" style="width: 25%;">
							<span>{{printInfo.orderCode}}</span>
						</el-form-item>
						
					</div>
					<div style="display: flex;justify-content: space-between;height:30px;">
						<el-form-item label="供货单位:" style="width: 45%;">
							<span>{{printInfo.csource}}</span>
						</el-form-item>
						<el-form-item label="客户订单号:" style="width: 30%;">
							<span>{{printInfo.customerOrderCode}}</span>
						</el-form-item>
						<el-form-item label="车牌号码:" style="width: 25%;">
							<span>{{printInfo.carNo}}</span>
						</el-form-item>
						   
					</div>
					<div style="display: flex;height:30px;justify-content: space-between;">
						<el-form-item label="备注:" style="width: 100%;">
							<span>{{printInfo.memo}}</span>
						</el-form-item>
						<el-form-item label="打印时间:" style="text-align: right;">
							<span id="pintTimeID"></span>
							<span style="padding-left:10px;">第</span>
							<span style="padding:0 5px;">{{ printInfo.printTimes+1 }}</span>
							<span>次打印</span>
						</el-form-item> 
					</div>
					<!-- <div style="height:30px;display: flex;justify-content: flex-end;">
						<el-form-item label="打印时间:" >
							<span id="pintTimeID"></span>
							<span style="padding-left:10px;">第</span>
							<span style="padding:0 5px;">{{ printInfo.printTimes+1 }}</span>
							<span>次打印</span>
						</el-form-item>   
					</div> -->
					
					<div style="width: auto;position: relative;">
						<table  cellspacing="0" cellpadding="0" border="1" style="background-color: #fff;">
							<thead>
								<tr>
									<td>商品编号</td>
									<td style="width:300px;">商品名称</td>
									<td>商品状态</td>
									<td>批次</td>
									<td style="width:60px;">计划数</td>
									<td style="width:85px;">计划数EA</td>
									<td style="width:60px;">实收</td>
									<td>库位</td>
									<td>备注</td>
								</tr>
							</thead>
							<tbody >
								<tr v-for="(item, index) in printDataList" :key="index" >
									<td>{{ item.pdtCode }}</td>
									<td>{{ item.pdtName }}</td>
									<td>{{ item.goodsStatusName }}</td>
									<td>{{ item.batchNo }}</td>
									<td>{{ item.num }}箱</td>
									<td>{{ item.eaNum }}{{item.unitName}}</td>
									<td></td>
									<td>{{ item.warehouseLocationName }}</td>
									<td>{{ item.remark }}</td>
								</tr>
								<tr>
									<td>数量合计</td>
									<td></td>
									<td></td>
									<td></td>
									<td>{{ printInfo.numTotal }}箱</td>
									<td>{{ printInfo.eaNumTotal }}</td>
									<td></td>
									<td></td>
									<td></td>
								</tr>
							</tbody>
						</table>
						
					</div>
					<div  class="print-footer">
						<el-form-item label="制单人:" style="width: 25%;">
								<span>{{ printInfo.createBy }}</span>
							</el-form-item>
							<el-form-item label="收货人:" style="width: 25%;">
								<span>{{ printInfo.receiver }}</span>
							</el-form-item>
							<el-form-item label="装卸组:" style="width: 25%;">
								<span>{{ printInfo.stevedore }}</span>
							</el-form-item>
							<el-form-item label="作业时间:" style="width: 25%;">
								<span>{{ printInfo.beginDatetime }}</span> - <span>{{ printInfo.endDatetime }}</span>
							</el-form-item>
							<el-form-item label="" style="width: 25%;">
								<span>第1页/共1页</span>
							</el-form-item>
						<!-- <div style="display: flex;height:30px;">
							<el-form-item label="制单人:" style="width: 25%;">
								<span>{{ printInfo.createBy }}</span>
							</el-form-item>
							<el-form-item label="收货人:" style="width: 25%;">
								<span>{{ printInfo.receiver }}</span>
							</el-form-item>
							<el-form-item label="装卸组:" style="width: 25%;">
								<span>{{ printInfo.stevedore }}</span>
							</el-form-item>
							
						</div>
						<div style="display: flex;height:30px;">
							<el-form-item label="作业开始时间:" style="width: 50%;">
								<span>{{ printInfo.beginDatetime }}</span>
							</el-form-item>
							<el-form-item label="作业结束时间:" style="width: 50%;">
								<span>{{ printInfo.endDatetime }}</span>
							</el-form-item>
						</div> -->
					</div>
					
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	import goodsMagnifierZoom from '../../components/goods-zoom.vue';
	import printModal from '../../components/printModal.vue';

	// import moment from 'moment.js'
	import moment from 'moment'; 
	var qwer = moment().format('YYYYMMDD');
	// var pintTime = '';

	export default {
		props:['order'],
		name: "GoodsZoom",
		components: {
			goodsMagnifierZoom: goodsMagnifierZoom,
			printModal,
			// moment
		},
		data() {
			let that = this
			return {
				isReturn:true,
				detaillist: {},
				unitList: [],
				arsList:[],
				queryParam: '',
				isJoinCar:3,
				driverList:[],
				num: 1,
				flag:false,
				userList: [],
				storelinks: {
					status:0,
					number:0,
					billingType:1,
                    orderType: '', //typeList[0].typeKey
                    warehouseId: '', //entrepotList[0].id
                    customerId: '', //userList[0].id
					sendDate:this.Date()
				},
				orderInfo: {},
				goodsList: [],
				form: {},
				dataList: [
					{
                        pdtId: '',
						pdtName: '',
						remark: '',
                        unitName: '',
						pdtCode: '',
						goodsStatus: 'zp',
						batchNo: qwer,
                        // num: '',
                        // eaNum: '',
                        // warehouseLocationId: '',
					}
				],
				rightDataList: [
					{
                        qtyReceived: '',
						eaQtyReceived: '',
						warehouseLocationId: '',
						remark: '',
					}
				],
				formData: {},
				
				goodsDataList: [],
				contractList: [],
				typeList: [],
				ids:'',
				idStatus: '',
				aid:0,
				aidRight: 0,
				carNumberplate:'',
				routeList: [],
                isDataChangeCount:0,
                
                entrepotList: [],
                locationList: [],
                stateOfGoodsList: [], //货物状态
                orderID: '',
				pageTile: '',
				TableType: 0,

				printInfo: {},
				printDataList: [],
				pintTime: '',
				printObj : {
					id: 'printMe',//id
					popTitle: "入库通知单",//自定义设置标题
					extraHead: '', //最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
					preview: false, // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
					previewTitle: '', // 打印预览的标题（开启预览模式后出现）,
					previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
					zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）   
					previewBeforeOpenCallback() {}, //预览窗口打开之前的callback（开启预览模式调用）
					previewOpenCallback() {}, // 预览窗口打开之后的callback（开启预览模式调用）
					beforeOpenCallback() {}, // 开启打印前的回调事件
					openCallback() {}, // 调用打印之后的回调事件
					closeCallback() {
						that.init();
						that.getPrintInfo();
					}, //关闭打印的回调事件（无法确定点击的是确认还是取消）
					clickMounted() { 
						// console.log('点击v-print绑定的按钮了！')
						document.getElementById('pintTimeID').innerHTML = moment().format('YYYY-MM-DD HH:mm:ss');
						that.$api.warehouseWarrantPrint({
							orderId : that.$route.query.id
						}).then(res=>{
							if(res.state = 'success'){
								let info = JSON.parse(res.data.content);
								// that.printInfo.lastPrintDatetime = info.lastPrintDatetime;
								// that.printInfo.printTimes = info.printTimes;
								// console.log('1111--', res.data)
								// console.log('122--', JSON.parse(res.data.content))
							}
						})
					}, //点击v-print绑定的按钮了！
					url: '',
					standard: '',
					extraCss: '',
				},

				dialogVisibleSwiper: false,
				popupInfo: {
					batchNo: '',
					// eaNum: ''
				},
				popupGoodCodeList: [], //弹窗里的商品编码选择
				popupGoodStatusList: [], //弹窗里的商品状态选择
				popupGoodCodeSelectInfo: {}, //弹窗里的商品编码选择所带出的数据
				popupSLoading: false,
				warehouseChangeNum: 0,
            }
		},
		watch: {
			carNumberplate(newValue, oldValue) {
				this.isJoinCar=this.arsList.find(item=>item.carNumberplate==newValue).isJoinCar
			},
			storelinks:{
				handler(a,b){
					if(this.$route.query.id){
						this.isDataChangeCount++
					}else{
						this.isDataChangeCount++
					}
					
				},
				deep:true
			},
			'storelinks.routeId'(a,b){
			
				if(!this.$route.query.id){
					if(this.storelinks.billingType==1){
					
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceTrips
					
					}else if(this.storelinks.billingType==2){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceVolume*this.storelinks.number
					}else if(this.storelinks.billingType==3){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceWeight*this.storelinks.number
					
					}
					this.storelinks.driveSendReward=this.routeList.find(item=>item.id==a).driveSendReward
				}else{
					if(this.isDataChangeCount>1){
						if(this.storelinks.billingType==1){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceTrips
						
						}else if(this.storelinks.billingType==2){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceVolume*this.storelinks.number
						}else if(this.storelinks.billingType==3){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceWeight*this.storelinks.number
						
						}
						this.storelinks.driveSendReward=this.routeList.find(item=>item.id==a).driveSendReward
					}
				}
			
					
				
			},
			
			'storelinks.billingType'(a,b){
				if(!this.$route.query.id){
					if(a==1){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceTrips
						
					}else if(a==2){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceVolume*this.storelinks.number
					}else if(a==3){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceWeight*this.storelinks.number
					
					}
				}else{
					if(this.isDataChangeCount>1){
						if(a==1){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceTrips
				
						}else if(a==2){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceVolume*this.storelinks.number
						}else if(a==3){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceWeight*this.storelinks.number
						
						}
					}
				}
				
				
			},
			'storelinks.number'(a,b){
				if(!this.$route.query.id){
					if(this.storelinks.billingType==1){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceTrips
					}else if(this.storelinks.billingType==2){
					this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceVolume*a
					}else if(this.storelinks.billingType==3){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceWeight*a
					
					}
				}
				else{
					if(this.isDataChangeCount>1){
						if(this.storelinks.billingType==1){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceTrips
						}else if(this.storelinks.billingType==2){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceVolume*a
						}else if(this.storelinks.billingType==3){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceWeight*a
						
						}
					}
				}
			},
			
		},
		
		methods: {
			addCarousel(){
				this.dialogVisibleSwiper = true;
				this.popupGoodCodeList = [];
				this.popupInfo = {
					batchNo: '',
					// eaNum: 0
				};
				this.$api.getRightGoodsList({
					orderId: this.orderInfo.id
				}).then(res=>{
					if(res.state == 'success'){
						this.popupGoodCodeList = res.data;
						// this.popupGoodStatusList = res.data;
						// console.log('弹窗请求--', res.data)
					}else{
						this.$message.error(res.message);
					}
					
				})
				this.districtFocus();
			},
			popupGoodCodeChange(e){ //选择商品code
				let obj = {};
				obj = this.popupGoodCodeList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id == e; //筛选出匹配数据
				});
				this.popupGoodCodeSelectInfo = obj;
				// console.log('选择的商品--', obj)
				this.popupInfo.batchNo = obj.batchNo

				// this.popupInfo.obj = obj.obj;
				// this.popupInfo.pdtCode = obj.pdtCode;
				// this.popupInfo.pdtCode = obj.pdtCode;
				// this.popupInfo.pdtName = obj.pdtName;
				// this.popupInfo.unitName = obj.unitName;
				// this.popupInfo.volume = obj.volume;
				// this.popupInfo.weight = obj.weight;
			},
			popupNumBlur(){ //计划数失焦事件
				if(this.popupGoodCodeSelectInfo){
					// b.eaNum = Number(b.num) * Number(b.boxGauge)
					let boxGauge = this.popupGoodCodeSelectInfo.boxGauge
					this.popupInfo.eaNum = Number(this.popupInfo.num) * Number(boxGauge)
				}
			},
			popupSubmit(){ //弹窗提交
				this.popupSLoading = true;
				let parameter={
					orderId:this.orderInfo.id,
                    num: this.popupInfo.num,
                    eaNum: this.popupInfo.eaNum,
					// qtyReceived: this.popupInfo.num,
					// eaQtyReceived: this.popupInfo.eaNum,
					warehouseLocationId: this.popupInfo.warehouseLocationId,
					// remark: this.popupInfo.remark,
					pdtId: this.popupGoodCodeSelectInfo.pdtId,
					pdtCode: this.popupGoodCodeSelectInfo.pdtCode,
					pdtName: this.popupGoodCodeSelectInfo.pdtName,
					unitName: this.popupGoodCodeSelectInfo.unitName,
					goodsStatus: this.popupGoodCodeSelectInfo.goodsStatus,
					batchNo: this.popupGoodCodeSelectInfo.batchNo,
					volume: this.popupGoodCodeSelectInfo.volume,
					weight: this.popupGoodCodeSelectInfo.weight,
				}
				// console.log(data);
				this.$api.addWarehouseWarranOrderListRight(parameter).then(res=>{
					if(res.state=='success'){
						this.$api.getWarehouseWarrantInfoByID(this.orderInfo.id).then(res=>{
							if(res.state == 'success'){ 
								// this.dataList = res.data.detailChildren;
								this.rightDataList = res.data.children;
								// this.handleAdd()
								// this.rightHandleAdd(b)
							}else{
								this.$message.error(res.message);
							}
							
						})
						this.$message.success(res.message)
						this.dialogVisibleSwiper = false;
					}else{
						this.$message.error(res.message)
					}
					this.popupSLoading = false;
				})
			},
			addDialogClose(){ //弹窗关闭
				this.dialogVisibleSwiper = false
			},
			getPrintInfo(){
				this.$api.getWarehouseWarrantInfoByID(this.$route.query.id).then(res=>{
					// res.data=JSON.parse(this.$decrypt(res.data)).data
					this.printInfo = res.data;
					this.printDataList = res.data.children;
					let numTol = 0;
					let eaNumTol = 0;
					let qtyReceivedTol = 0;
					res.data.children.forEach(it=>{
						numTol = numTol+it.num
						eaNumTol = eaNumTol+it.eaNum
						qtyReceivedTol = qtyReceivedTol+it.qtyReceived
					})
					this.printInfo.numTotal = numTol;
					this.printInfo.eaNumTotal = eaNumTol;
					this.printInfo.qtyReceivedTotal = qtyReceivedTol;
				})
			},
			printDeliver(data) {
				// this.$refs.printModal.handlePrint();
				// this.$api.warehouseWarrantPrint({
				// 	orderId : 38
				// }).then(res=>{
				// 	console.log('122--', JSON.parse(res.data.content))
				// 	this.printInfo = JSON.parse(res.data.content);
				// 	this.printDataList = JSON.parse(res.data.content).children;

				// })
				// this.$nextTick(()=>{
				// 	const ele = proxy.$refs.printBtn.$sel
				// 	const cli = new MouseEvent('click')
				// 	ele.dispatchEvent(cli)
				// })
				
				setTimeout(() => {
					this.$print(this.$refs.printContent);
					// this.$print(this.printObj);
				}, 1000);
				// this.$refs.printBtn.click();
			},
			printClick(){
				if(this.orderID){
					this.$router.push({
						path: 'print',
						query:{
							id: this.orderID, 
						}
					})
				}
				
			},
			orderTypeChange(e){ //订单类型选择
				let obj = {};
				obj = this.typeList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.typeKey === e; //筛选出匹配数据
				});
				// obj.prefix //前缀
				// console.log('订单类型选择---', obj)
				let serialNumber = obj.prefix;
				this.$api.getSerialNumber().then(res => { //序列号
					if(res.state=='success'){
						// console.log('4455--', res.message)
						serialNumber = serialNumber+res.message
						this.storelinks.orderCode = serialNumber
						// console.log('订单号---', serialNumber)
					}
				})
			},
            dialogVisible(){

            },
			customerSelect(e){
                let obj = {};
				obj = this.userList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
                });
                this.storelinks.customerName = obj.customerName
            },
			carchange(it){
				
			},
			Date(){
				 const now = new Date();
					const year = now.getFullYear(); // 获取当前年份
					const month = now.getMonth() + 1; // 月份从 0 开始，所以要加1
					const day = now.getDate(); // 获取当前日期
				return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`
			},
			wanc(){
				
				this.$api.completeByID(this.orderInfo.id).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.init();
					} else {
						this.$message.error(res.message);
					}
				})
			},
			changesj(e){
				
				this.carNumberplate=e.carNumberplate
			},
			// 左边表格操作 - 开始
            handleRowClick(row, event, column) {
                // row 对象即为点击的行数据
                this.$nextTick(()=>{
                    this.aid=row.id
                })
			},
			input(e) {
				this.goodsDataList=[]
				this.$api.findgs(this.$encrypt({
					queryParam: e
				})).then(res => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.data.length > 0) {
						res.data.forEach((item,index)=> {
                            // console.log('下拉选择的商品信息---', item)
							this.goodsDataList.push({
								pdtName: item.pdtName,
								pdtId:item.id,
								pdtCode: item.pdtCode,
								unitName: item.unitName,
								boxGauge: item.boxGauge,
							}) 
						})
						this.flag=true
					} else {
						this.goodsDataList = []
					}


				})
			},
			change(e){
				// if(b.id && this.TableType==1){
				// 	this.$message.error('入库中商品不可修改');
				// 	return
				// }
				this.ids = e
				// let obj = {};
				// obj = this.goodsDataList.find((item) => { //这里的userList就是上面遍历的数据源
				// 	return item.pdtCode == e; //筛选出匹配数据
				// });
				// console.log('商品---', obj)
				// console.log('参数1--', a)
				// console.log('参数2--', e)
			},
			asd(a,e){
				this.$set(this.dataList[a],'pdtCode',this.goodsDataList[this.ids].pdtCode)
				this.$set(this.dataList[a],'unitName',this.goodsDataList[this.ids].unitName)
                this.$set(this.dataList[a],'id',this.dataList[a].id)
                this.$set(this.dataList[a],'pdtName',this.goodsDataList[this.ids].pdtName)
                this.$set(this.dataList[a],'pdtId',this.goodsDataList[this.ids].pdtId)
                this.$set(this.dataList[a],'boxGauge',this.goodsDataList[this.ids].boxGauge)
            },
            kuwei(a,e){
                // this.$set(this.dataList[a],'pdtCode',this.goodsDataList[this.ids].pdtCode)
				// this.$set(this.dataList[a],'unitName',this.goodsDataList[this.ids].unitName)
                // this.$set(this.dataList[a],'id',this.dataList[a].id)
                // this.$set(this.dataList[a],'pdtName',this.goodsDataList[this.ids].pdtName)
				// this.$set(this.dataList[a],'pdtId',this.goodsDataList[this.ids].pdtId)
            },
			keydown(index,b,c){ //键盘回车事件
				if(b.id && this.TableType==1){
					if(c == 'batchNo'){
						this.$message.error('入库中批次不可修改');
                    	return
					}
					if(c == 'num'){
						this.$message.error('入库中计划数不可修改');
                    	return
					}
					if(c == 'eaNum'){
						this.$message.error('入库中计划EA数不可修改');
                    	return
					}
				}
				if(c == 'num'){
					// b.qtyReceived = b.num
					if(b.boxGauge){
						b.eaNum = Number(b.num) * Number(b.boxGauge)
						// b.eaQtyReceived = b.eaNum
					}else{
						b.eaNum = b.eaNum
						// b.eaQtyReceived = b.eaNum
					}
					
				}
				// if(c == 'eaNum'){
				// 	b.eaQtyReceived = b.eaNum
				// }
				let a='sel'+(index+1)
				let data={
					orderId:this.orderInfo.id,
					pdtName:b.pdtName,
					pdtId:b.pdtId,
					pdtCode:b.pdtCode,
					unitName:b.unitName,
					remark:b.remark,
                    num:b.num,
                    eaNum: b.eaNum,
                    goodsStatus: b.goodsStatus,
					qtyReceived: b.qtyReceived,
					eaQtyReceived: b.eaQtyReceived,
                    // volume: b.volume,
                    // weight: b.weight,
                    batchNo: b.batchNo,
                    warehouseLocationId: b.warehouseLocationId
				}
				// console.log('编辑或新增的表格数据---', data)		
				if(b.id){ //编辑
					this.$api.updateWarehouseWarranOrderList({...data, id:b.id}).then(res=>{
						// res=JSON.parse(this.$decrypt(res.data))
						// console.log('失焦时间数据返回--',res);
						if(res.state=='success'){
							// this.dataList=res.data
							this.$nextTick(()=>{
								document.getElementById(a).focus();
							})
							// this.rightDataList = res.data.detailChildren;
							// this.handleAdd()
							this.getRightGoodStorageLocation(this.orderInfo.id)
						}else{
							this.$message.error(res.message)
						}
					})
				}else{ //新增
					// console.log(data);
					this.$api.addWarehouseWarranOrderList(data).then(res=>{
						// console.log('失焦时间数据返回--',res);
						// res=JSON.parse(this.$decrypt(res.data))
						if(res.state=='success'){
							// this.dataList=res.data
							this.$nextTick(()=>{
								document.getElementById(a).focus();
							})
							// this.handleAdd()
							this.getRightGoodStorageLocation(this.orderInfo.id)
						}else{
							this.$message.error(res.message)
						}
					})
				}
				
			},
			tableBC(index,b){ //表格操作列保存事件
				let a='sel'+(index+1)
				let data={
					orderId:this.orderInfo.id,
					pdtName:b.pdtName,
					pdtId:b.pdtId,
					pdtCode:b.pdtCode,
					unitName:b.unitName,
					remark:b.remark,
                    num:b.num,
                    eaNum: b.eaNum,
                    goodsStatus: b.goodsStatus,
					qtyReceived: b.qtyReceived,
					eaQtyReceived: b.eaQtyReceived,
                    // volume: b.volume,
                    // weight: b.weight,
                    batchNo: b.batchNo,
                    warehouseLocationId: b.warehouseLocationId
				}
				// console.log('编辑或新增的表格数据---', data)		
				if(b.id){ //编辑
					this.$api.updateWarehouseWarranOrderList({...data, id:b.id}).then(res=>{
						// res=JSON.parse(this.$decrypt(res.data))
						// console.log('失焦时间数据返回--',res);
						if(res.state=='success'){
							// this.dataList=res.data
							this.$nextTick(()=>{
								document.getElementById(a).focus();
							})
							// this.handleAdd()
							// this.getRightGoodStorageLocation(this.orderInfo.id)
							this.$api.getWarehouseWarrantInfoByID(this.orderInfo.id).then(res=>{
								if(res.state == 'success'){
									this.dataList = res.data.detailChildren;
									this.rightDataList = res.data.children;
									// this.handleAdd()
								}else{
									this.$message.error(res.message);
								}
								
							})
						}else{
							this.$message.error(res.message)
						}
					})
				}else{ //新增
					// console.log(data);
					this.$api.addWarehouseWarranOrderList(data).then(res=>{
						// console.log('失焦时间数据返回--',res);
						// res=JSON.parse(this.$decrypt(res.data))
						if(res.state=='success'){
							// this.dataList=res.data
							this.$nextTick(()=>{
								document.getElementById(a).focus();
							})
							// this.handleAdd()
							this.getRightGoodStorageLocation(this.orderInfo.id)
						}else{
							this.$message.error(res.message)
						}
					})
				}
				
			
			},
			inputInput(index,b,c){
				// console.log('箱规2--', b)
				if(c=='num' && b.num==0){
					this.$message.error('计划数不可以为0');
					return
				}
				if(c=='eaNum' && b.eaNum==0){
					this.$message.error('计划数EA不可以为0');
					return
				}

				if(c == 'num'){
					b.qtyReceived = b.num
					if(b.boxGauge){
						b.eaNum = Number(b.num) * Number(b.boxGauge)
						b.eaQtyReceived = b.eaNum
						// console.log('b.eaNum--', b.eaNum)
					}else{
						b.eaNum = b.eaNum
						b.eaQtyReceived = b.eaNum
					}
					return
				}
				if(c == 'eaNum'){
					b.eaQtyReceived = b.eaNum
					return
				}
			},
			inputBlur(index,b,c){ //表格输入框失焦事件
				// console.log('箱规1--', b)
				// console.log('入库中--', b.id && this.TableType==1)
				if(b.id && this.TableType==1){
					if(c == 'batchNo'){
						this.$message.error('入库中批次不可修改');
                    	return
					}
					if(c == 'num'){
						this.$message.error('入库中计划数不可修改');
                    	return
					}
					if(c == 'eaNum'){
						this.$message.error('入库中计划EA数不可修改');
                    	return
					}
				}
				// if(c == 'num'){
				// 	b.qtyReceived = b.num
				// 	if(b.boxGauge){
				// 		b.eaNum = Number(b.num) * Number(b.boxGauge)
				// 		b.eaQtyReceived = b.eaNum
				// 		console.log('b.eaNum--', b.eaNum)
				// 	}else{
				// 		b.eaNum = b.eaNum
				// 		b.eaQtyReceived = b.eaNum
				// 	}
					
				// }
				// if(c == 'eaNum'){
				// 	b.eaQtyReceived = b.eaNum
				// }
				let a='sel'+(index+1)
				let data={
					orderId:this.orderInfo.id,
					pdtName:b.pdtName,
					pdtId:b.pdtId,
					pdtCode:b.pdtCode,
					unitName:b.unitName,
					remark:b.remark,
                    num: b.num,
                    eaNum: b.eaNum,
                    goodsStatus: b.goodsStatus,
					qtyReceived: b.qtyReceived,
					eaQtyReceived: b.eaQtyReceived,
                    // volume: b.volume,
                    // weight: b.weight,
                    batchNo: b.batchNo,
                    warehouseLocationId: b.warehouseLocationId
				}
				// console.log('编辑或新增的表格数据---', data)		
				if(b.id){ //编辑
					this.$api.updateWarehouseWarranOrderList({...data, id:b.id}).then(res=>{
						// res=JSON.parse(this.$decrypt(res.data))
						// console.log('失焦时间数据返回--',res);
						if(res.state=='success'){
							// this.dataList=res.data
							this.$nextTick(()=>{
								document.getElementById(a).focus();
							})
							this.getRightGoodStorageLocation(this.orderInfo.id)
							// this.handleAdd()
						}else{
							this.$message.error(res.message)
						}
					})
				}else{ //新增
					// console.log(data);
					this.$api.addWarehouseWarranOrderList(data).then(res=>{
						// console.log('失焦时间数据返回--',res);
						// res=JSON.parse(this.$decrypt(res.data))
						if(res.state=='success'){
							// this.dataList=res.data
							this.$nextTick(()=>{
								document.getElementById(a).focus();
							})
							this.getRightGoodStorageLocation(this.orderInfo.id)
							// this.handleAdd()
						}else{
							this.$message.error(res.message)
						}
					})
				}
				
			},
			select(a,item,index) {
				// console.log('122--',item);
				// console.log('133--',this.dataList);
			   // this.dataList[a]=item
				this.$set(this.dataList[a],'pdtName',item.pdtName)
				this.$set(this.dataList[a],'pdtId',item.pdtId)
				this.$set(this.dataList[a],'index',index)
				this.$set(this.dataList[a],'pdtCode',item.pdtCode)
				this.$set(this.dataList[a],'unitName',item.unitName)
				this.$set(this.dataList[a],'boxGauge',item.boxGauge)
			},
			// 添加行
			handleAdd() {
				var _this = this
				let list = {
					pdtName: '',
					remark: '',
					goodsStatus: 'zp',
					unitName: '',
					batchNo: moment().format('YYYYMMDD'),
				}
				// list.batchNo = moment().format('YYYYMMDD')
				// console.log('', moment().format('YYYYMMDD'))
				_this.dataList.push(list)
			},
			// 删除行
			handleDelete(index, row) {
				var _this = this
				this.$api.deldWarehouseWarranOrder(row.id).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						// _this.dataList.splice(index, 1)
						this.getRightGoodStorageLocation(this.orderInfo.id)
					} else {
						this.$message.error(res.message);
					}
				})
			},
			// 左边表格操作 - 结束

			// 右边边表格操作 - 开始
			handleRowClickRight(row, event, column) {
                // row 对象即为点击的行数据
                this.$nextTick(()=>{
                    this.aidRight=row.id
                })
			},
			kuweiRight(a,e){
				
			},
			kuweiSelectRight(index,it,b) {
				// if(this.warehouseChangeNum!=0){
				// 	this.$message.error('仓库变动了,请先保存!')
				// 	return
				// }
				// console.log('库位选择了--', b)
				let parameter={
					orderId:this.orderInfo.id,
                    num: b.num,
                    eaNum: b.eaNum,
					qtyReceived: b.qtyReceived,
					eaQtyReceived: b.eaQtyReceived,
					warehouseLocationId: b.warehouseLocationId,
					remark: b.remark,
					pdtId: b.pdtId
				}
				if(b.id){ //编辑
					this.$api.updateWarehouseWarranOrderListRight({...parameter, ...b}).then(res=>{
						// res=JSON.parse(this.$decrypt(res.data))
						// console.log('失焦时间数据返回--',res);
						if(res.state=='success'){
							// this.rightDataList = res.data
							// this.$nextTick(()=>{
							// 	document.getElementById(a).focus();
							// })
							this.$api.getWarehouseWarrantInfoByID(this.orderInfo.id).then(res=>{
								if(res.state == 'success'){
									// this.dataList = res.data.detailChildren;
									this.rightDataList = res.data.children;
									// this.handleAdd()
									// this.rightHandleAdd(b)
								}else{
									this.$message.error(res.message);
								}
								
							})
							
							this.$message.success(res.message)
						}else{
							this.$message.error(res.message)
						}
					})
				}else{ //新增
					// console.log(data);
					this.$api.addWarehouseWarranOrderListRight({...parameter, ...b}).then(res=>{
						// console.log('失焦时间数据返回--',res);
						// res=JSON.parse(this.$decrypt(res.data))
						if(res.state=='success'){
							// this.rightDataList[index] = res.data
							// this.$nextTick(()=>{
							// 	document.getElementById(a).focus();
							// })
							// this.rightHandleAdd(b)
							this.$api.getWarehouseWarrantInfoByID(this.orderInfo.id).then(res=>{
								if(res.state == 'success'){ 
									// this.dataList = res.data.detailChildren;
									this.rightDataList = res.data.children;
									// this.handleAdd()
									// this.rightHandleAdd(b)
								}else{
									this.$message.error(res.message);
								}
								
							})
							this.$message.success(res.message)
						}else{
							this.$message.error(res.message)
						}
					})
				}
			},
			// 添加行
			rightHandleAdd(b) {
				var _this = this
				// console.log('新增一行右边的--', b)
				let list = {
					warehouseLocationId: '',
					remark: '',
					num: b.num,
                    eaNum: b.eaNum,
					qtyReceived: '',
					eaQtyReceived: '',
					pdtId:b.pdtId,
					pdtCode:b.pdtCode,
					pdtName: b.pdtName,
					goodsStatusName: b.goodsStatusName,
					goodsStatus: b.goodsStatus,
					batchNo: b.batchNo,
				}
				_this.rightDataList.push(list)
			},
			//删除行
			handleDeleteRight(index, row) {
				// console.log('删除行信息--', row)
				var _this = this
				this.$api.deldWarehouseWarranOrderRight(row.id).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						_this.rightDataList.splice(index, 1)
					} else {
						this.$message.error(res.message);
					}
				})
			},
			keydownRigt(index,b,c){ //键盘回车事件
				let a='selRight'+(index+1)
				if(c == 'num'){
					b.qtyReceived = b.num
				}
				if(c == 'eaNum'){
					b.eaQtyReceived = b.eaNum
				}
				let parameter={
					orderId:this.orderInfo.id,
                    num: b.num,
                    eaNum: b.eaNum,
					qtyReceived: b.qtyReceived,
					eaQtyReceived: b.eaQtyReceived,
					warehouseLocationId: b.warehouseLocationId,
					remark: b.remark,
					pdtId: b.pdtId
				}
				if(b.id){ //编辑
					this.$api.updateWarehouseWarranOrderListRight({...parameter, ...b}).then(res=>{
						// res=JSON.parse(this.$decrypt(res.data))
						// console.log('失焦时间数据返回--',res);
						if(res.state=='success'){
							// this.rightDataList = res.data
							// this.$nextTick(()=>{
							// 	document.getElementById(a).focus();
							// })
							this.$api.getWarehouseWarrantInfoByID(this.orderInfo.id).then(res=>{
								if(res.state == 'success'){
									// this.dataList = res.data.detailChildren;
									this.rightDataList = res.data.children;
									// this.handleAdd()
									// this.rightHandleAdd(b)
								}else{
									this.$message.error(res.message);
								}
								
							})
							
							this.$message.success(res.message)
						}else{
							this.$message.error(res.message)
						}
					})
				}else{ //新增
					// console.log(data);
					this.$api.addWarehouseWarranOrderListRight({...parameter, ...b}).then(res=>{
						// console.log('失焦时间数据返回--',res);
						// res=JSON.parse(this.$decrypt(res.data))
						if(res.state=='success'){
							// this.rightDataList[index] = res.data
							// this.$nextTick(()=>{
							// 	document.getElementById(a).focus();
							// })
							// this.rightHandleAdd(b)
							this.$api.getWarehouseWarrantInfoByID(this.orderInfo.id).then(res=>{
								if(res.state == 'success'){ 
									// this.dataList = res.data.detailChildren;
									this.rightDataList = res.data.children;
									// this.handleAdd()
									// this.rightHandleAdd(b)
								}else{
									this.$message.error(res.message);
								}
								
							})
							this.$message.success(res.message)
						}else{
							this.$message.error(res.message)
						}
					})
				}	
				
			},
			inputInputRight(index,b,c){

				// if(c == 'num'){
				// 	b.qtyReceived = b.num
				// }
				// if(c == 'eaNum'){
				// 	b.eaQtyReceived = b.eaNum
				// }

				// console.log('箱规2--', b)
				if(c=='num' && b.num==0){
					this.$message.error('计划数不可以为0');
					return
				}
				if(c=='eaNum' && b.eaNum==0){
					this.$message.error('计划数EA不可以为0');
					return
				}

				if(c == 'num'){
					b.qtyReceived = b.num
					if(b.boxGauge){
						b.eaNum = Number(b.num) * Number(b.boxGauge)
						b.eaQtyReceived = b.eaNum
						// console.log('b.eaNum--', b.eaNum)
					}else{
						b.eaNum = b.eaNum
						b.eaQtyReceived = b.eaNum
					}
					return
				}
				if(c == 'eaNum'){
					b.eaQtyReceived = b.eaNum
					return
				}
			},
			inputBlurRight(index,b,c){ //表格输入框失焦事件
				let a='selRight'+(index+1)
				// console.log('编辑或新增---', b)
				// if(c == 'num' || c == 'eaNum'){
				// 	if(b.num<=0 ||b.eaNum<=0){
				// 		this.$message.error('不可输入小于等于0的数')
				// 		return
				// 	}
				// }
				// if(c == 'num'){
				// 	b.qtyReceived = b.num
				// }
				// if(c == 'eaNum'){
				// 	b.eaQtyReceived = b.eaNum
				// }
				let parameter={
					orderId:this.orderInfo.id,
                    num: b.num,
                    eaNum: b.eaNum,
					qtyReceived: b.qtyReceived,
					eaQtyReceived: b.eaQtyReceived,
					warehouseLocationId: b.warehouseLocationId,
					remark: b.remark,
					pdtId: b.pdtId
				}
				if(b.id){ //编辑
					this.$api.updateWarehouseWarranOrderListRight({...parameter, ...b}).then(res=>{
						// res=JSON.parse(this.$decrypt(res.data))
						// console.log('失焦时间数据返回--',res);
						if(res.state=='success'){
							// this.rightDataList = res.data
							// this.$nextTick(()=>{
							// 	document.getElementById(a).focus();
							// })
							this.$api.getWarehouseWarrantInfoByID(this.orderInfo.id).then(res=>{
								if(res.state == 'success'){
									// this.dataList = res.data.detailChildren;
									this.rightDataList = res.data.children;
									// this.handleAdd()
									// this.rightHandleAdd(b)
								}else{
									this.$message.error(res.message);
								}
								
							})
							
							this.$message.success(res.message)
						}else{
							this.$message.error(res.message)
						}
					})
				}else{ //新增
					// console.log(data);
					this.$api.addWarehouseWarranOrderListRight({...parameter, ...b}).then(res=>{
						// console.log('失焦时间数据返回--',res);
						// res=JSON.parse(this.$decrypt(res.data))
						if(res.state=='success'){
							// this.rightDataList[index] = res.data
							// this.$nextTick(()=>{
							// 	document.getElementById(a).focus();
							// })
							// this.rightHandleAdd(b)
							this.$api.getWarehouseWarrantInfoByID(this.orderInfo.id).then(res=>{
								if(res.state == 'success'){ 
									// this.dataList = res.data.detailChildren;
									this.rightDataList = res.data.children;
									// this.handleAdd()
									// this.rightHandleAdd(b)
								}else{
									this.$message.error(res.message);
								}
								
							})
							this.$message.success(res.message)
						}else{
							this.$message.error(res.message)
						}
					})
				}
				
			},
			tableBCRight(index,b){ //表格操作列保存事件
				let a='selRight'+(index+1)
				let parameter={
					orderId:this.orderInfo.id,
                    num: b.num,
                    eaNum: b.eaNum,
					qtyReceived: b.qtyReceived,
					eaQtyReceived: b.eaQtyReceived,
					warehouseLocationId: b.warehouseLocationId,
					remark: b.remark,
					pdtId: b.pdtId
				}
				if(b.id){ //编辑
					this.$api.updateWarehouseWarranOrderListRight({...parameter, ...b}).then(res=>{
						// res=JSON.parse(this.$decrypt(res.data))
						// console.log('失焦时间数据返回--',res);
						if(res.state=='success'){
							// this.rightDataList = res.data
							// this.$nextTick(()=>{
							// 	document.getElementById(a).focus();
							// })
							this.$api.getWarehouseWarrantInfoByID(this.orderInfo.id).then(res=>{
								if(res.state == 'success'){
									// this.dataList = res.data.detailChildren;
									this.rightDataList = res.data.children;
									// this.handleAdd()
									// this.rightHandleAdd(b)
								}else{
									this.$message.error(res.message);
								}
								
							})
							
							this.$message.success(res.message)
						}else{
							this.$message.error(res.message)
						}
					})
				}else{ //新增
					// console.log(data);
					this.$api.addWarehouseWarranOrderListRight({...parameter, ...b}).then(res=>{
						// console.log('失焦时间数据返回--',res);
						// res=JSON.parse(this.$decrypt(res.data))
						if(res.state=='success'){
							// this.rightDataList[index] = res.data
							// this.$nextTick(()=>{
							// 	document.getElementById(a).focus();
							// })
							// this.rightHandleAdd(b)
							this.$api.getWarehouseWarrantInfoByID(this.orderInfo.id).then(res=>{
								if(res.state == 'success'){ 
									// this.dataList = res.data.detailChildren;
									this.rightDataList = res.data.children;
									// this.handleAdd()
									// this.rightHandleAdd(b)
								}else{
									this.$message.error(res.message);
								}
								
							})
							this.$message.success(res.message)
						}else{
							this.$message.error(res.message)
						}
					})
				}
			},	
			// 右边表格操作 - 结束

			submitClick(){
				// this.warehouseChangeNum = 0;
				if (this.$vnode && this.$vnode.data.keepAlive) {
					if (this.$vnode.parent && this.$vnode.parent.componentInstance && this.$vnode.parent.componentInstance
						.cache) {
						if (this.$vnode.componentOptions) {
							var key = this.$vnode.key == null ? this.$vnode.componentOptions.Ctor.cid + (this.$vnode
								.componentOptions.tag ?
								`::${this.$vnode.componentOptions.tag}` : '') : this.$vnode.key;
							var cache = this.$vnode.parent.componentInstance.cache;
							var keys = this.$vnode.parent.componentInstance.keys;
							if (cache[key]) {
								if (keys.length) {
									var index = keys.indexOf(key);
									if (index > -1) {
										keys.splice(index, 1);
									}
								}
								delete cache[key];
							}
						}
					}
				}
				// console.log('22--', this.isDataChangeCount)
                if(this.storelinks.warehouseId){}else{
                    this.$message.error('入库仓库不能为空');
                    return
                }

                if(this.storelinks.orderType){}else{
                    this.$message.error('订单类型不能为空');
                    return
                }

                if(this.storelinks.customerId){}else{
                    this.$message.error('客户不能为空');
                    return
                }

                if(this.storelinks.orderCode){}else{
                    this.$message.error('入库单号不能为空');
                    return
                }
               
                if(this.storelinks.customerOrderCode){}else{
                    this.$message.error('客户订单号不能为空');
                    return
                }
                let data={
                    // ...this.storelinks,
                    warehouseId: this.storelinks.warehouseId, //入库仓库
                    orderType: this.storelinks.orderType, //订单类型
                    orderCode: this.storelinks.orderCode, //入库单号
                    customerId: this.storelinks.customerId, //客户
                    customerName: this.storelinks.customerName, //客户名称
                    csource: this.storelinks.csource, //供货单位
                    customerOrderCode: this.storelinks.customerOrderCode, //客户订单号
                    carNo: this.storelinks.carNo, //车牌号码
                    // volume: this.storelinks.volume, //体积
                    // weight: this.storelinks.weight, //重量
                    receiver: this.storelinks.receiver, //收货人
                    stevedore: this.storelinks.stevedore, //装卸组
                    memo: this.storelinks.memo, //备注
                    beginDatetime: this.storelinks.beginDatetime, //开始时间
					endDatetime:this.storelinks.endDatetime, //结束时间
					storageTime: this.storelinks.storageTime, //入库时间
                }
                // console.log('点击提交按钮提交的数据---', data)
                // this.$encrypt(data)
                // if(this.orderID){ //编辑
				// data.id = this.orderID,
				data.id = this.orderInfo.id;
				this.$api.updateWarehouseWarranOrder(data).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						setTimeout(()=>{
							// this.$router.go(-1)
							this.$router.push({
								path: '/warehouseBill/enter'
							})
							this.$store.commit('setactiveindex', '/warehouseBill/enter')
						},1000)
						// this.isDataChangeCount--;
					} else {
						this.$message.error(res.message);
					}
				})
                // }else{
                //     this.$api.addWarehouseWarranOrder(data).then(res=>{
                //         if (res.state == 'success') {
                //             this.$message({
                //                 message: res.message,
                //                 type: 'success'
                //             });
                //             setTimeout(()=>{
                //                 this.$router.go(-1)
                //             },1000)
                //             // this.pageTile = '编辑';
                //             // this.orderID = res.data.id;
                //             // this.orderInfo = res.data;
                //             // this.storelinks = res.data;
				// 			// this.isDataChangeCount = 0;
				// 			// console.log('33--', this.isDataChangeCount)
                //         } else {
                //             this.$message.error(res.message);
                //         }
                //     })
                // }
				
			},
            kuweiSelect(a,item,index) {
			   // this.dataList[a]=item
				// this.$set(this.dataList[a],'pdtName',item.pdtName)
				// this.$set(this.dataList[a],'pdtId',item.pdtId)
				// this.$set(this.dataList[a],'index',index)
				// this.$set(this.dataList[a],'pdtCode',item.pdtCode)
				// this.$set(this.dataList[a],'unitName',item.unitName)
            },
			goscroll(e) {
			
			},
			goBack() {
				topTarget.scrollIntoView();
			},
			
			go() {  
                // console.log('未知---', this.isDataChangeCount)
				if(this.storelinks.status==2){
					this.$router.go(-1)
				}else{
					if(this.$route.query.id){
						if(this.isDataChangeCount>1){
							this.$message.error('还有待提交数据，请先提交')
						}
						else{
							this.$router.go(-1)
						}
					}else{
						if(this.isDataChangeCount>0){
							this.$message.error('还有待提交数据，请先提交')
						}
						else{
							this.$router.go(-1)
						}
					}
				}			
			},
			getRightGoodStorageLocation(id){ //查询右边商品储存库位
				this.$api.getWarehouseWarrantInfoByID(id).then(res=>{
					if(res.state == 'success'){
						this.dataList = res.data.detailChildren;
						this.rightDataList = res.data.children;
						this.handleAdd()
					}else{
						this.$message.error(res.message);
					}
					
				})
			},
			init(){ //编辑查询
				this.$api.getWarehouseWarrantInfoByID(this.$route.query.id).then(res=>{
					// res.data=JSON.parse(this.$decrypt(res.data)).data
					this.storelinks = res.data
					// this.formData = JSON.parse(JSON.stringify(res.data))
                    // console.log('根据ID查询--', res.data)
                    // this.carNumberplate=res.data.carNumberplate
                    this.orderID = res.data.id;
					this.orderInfo = res.data;
					this.dataList = res.data.detailChildren;
					this.rightDataList = res.data.children;
					this.TableType = res.data.status;
					this.$api.getLocationListNoParameter({
						warehouseLocationName: '',
						warehouseId: res.data.warehouseId,
						status: 1
					}).then((res) => {
						// console.log('2344--',res.data)
						if (res.state == 'success') {
							this.locationList = res.data
						}
					})
					// console.log('表格状态数---', this.TableType)
					if(this.storelinks.status==0){ //0=制单中；1=入库中，2=关单
						this.dataList.push({
							pdtId: '',
                            pdtName: '',
                            remark: '',
                            unitName: '',
							pdtCode: '',
							goodsStatus: 'zp',
							batchNo: qwer
						})
						
						// this.rightDataList.push({
						// 	qtyReceived: '',
						// 	eaQtyReceived: '',
						// 	warehouseLocationId: '',
						// 	remark: '',
						// })
					}
					
				})
			},
			// 入库
			toBlockUp() {
				if(this.$route.query.id){
					if(this.isDataChangeCount>1){
						this.$message.error('还有待提交数据，请先提交')
						return
					}
				}else{
					if(this.isDataChangeCount>0){
						this.$message.error('还有待提交数据，请先提交')
						return
					}
				}
				// console.log(e)
				var str = "此操作将入库, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.warehouseWarrantUpdateStatus(this.orderID).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.init()
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			// 关单
			toStartUsing() {
				if(this.$route.query.id){
					if(this.isDataChangeCount>1){
						this.$message.error('还有待提交数据，请先提交')
						return
					}
				}else{
					if(this.isDataChangeCount>0){
						this.$message.error('还有待提交数据，请先提交')
						return
					}
				}
				// console.log(e)
				var str = "此操作将关单, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.warehouseWarrantUpdateStatus(this.orderID).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.init()
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			save(type) {
                // console.log(`调用保存按钮方法--${type}`);
            },
			saveContent(e) {
			   var key = window.event.keyCode ? window.event.keyCode : window.event.which;
			   if (key === 83 && e.ctrlKey) {
			     this.save("hot key");
			     e.preventDefault(); //阻止浏览器默认事件
			   }
            },
            WarehouseLis(e){
                this.$api.getWarehouseListByNowUser({
                    status: 1,
                    warehouseName: e
				}).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.entrepotList = res.data
					}
				})
            },
            getStateOfGoodsListI(){ //货物状态查看
                this.$api.getStateOfGoodsList().then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.stateOfGoodsList = res.data
					}
				})
			},
			warehouseChange(e){ //仓库选择
				// this.warehouseChangeNum++;
				this.$api.getLocationListNoParameter({
                    warehouseLocationName: '',
                    warehouseId: e,
                    status: 1
                }).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.locationList = res.data
					}
				})
				let data={
                    // ...this.storelinks,
					warehouseId: this.storelinks.warehouseId, //入库仓库
					id : this.orderInfo.id,
                    orderType: this.storelinks.orderType, //订单类型
                    orderCode: this.storelinks.orderCode, //入库单号
                    customerId: this.storelinks.customerId, //客户
                    customerName: this.storelinks.customerName, //客户名称
                    csource: this.storelinks.csource, //供货单位
                    customerOrderCode: this.storelinks.customerOrderCode, //客户订单号
                    carNo: this.storelinks.carNo, //车牌号码
                    // volume: this.storelinks.volume, //体积
                    // weight: this.storelinks.weight, //重量
                    receiver: this.storelinks.receiver, //收货人
                    stevedore: this.storelinks.stevedore, //装卸组
                    memo: this.storelinks.memo, //备注
                    beginDatetime: this.storelinks.beginDatetime, //开始时间
					endDatetime:this.storelinks.endDatetime, //结束时间
					storageTime: this.storelinks.storageTime, //入库时间
                }
				// data.id = this.orderInfo.id;
				this.$api.updateWarehouseWarranOrder(data).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.init();
						// this.isDataChangeCount--;
					} else {
						this.$message.error(res.message);
					}
				})
				
			},
            districtFocus(e){ //库位查询
                this.$api.getLocationListNoParameter({
                    warehouseLocationName: e,
                    warehouseId: this.storelinks.warehouseId,
                    status: 1
                }).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.locationList = res.data
					}
				})
			},
		},
		beforeDestroy() {
		    //销毁时移除监听
		    document.removeEventListener("keydown", this.saveContent);
		},
		mounted() {
			document.addEventListener("focus", this.saveContent);	
		},
		created() {
			// this.dataList[0].batchNo = moment().format('YYYYMMDD');
			if(this.$route.query.id){
                this.pageTile = '编辑';
				this.init();
				this.getPrintInfo();
			}else{
				this.pageTile = '新增';
				this.storelinks.storageTime = new Date();
                this.$api.addWarehouseWarranOrder().then(res=>{
					// console.log('创建---', res.data)
                    if(res.state=='success'){
						this.orderInfo = res.data; 
						// this.storelinks.status = 0;
                    }
                })
				this.$api.getUserInfo().then((res) => {
					// console.log(res);
					res.data = JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.storelinks.createBy = res.data.user.name
					}
				})
				this.dataList[0].batchNo = moment().format('YYYYMMDD')
				this.storelinks.storageTime = moment().format('YYYY-MM-DD')
			}
			// this.$api.fdriverList(this.$encrypt({})).then(res => { //司机
			// 	res.data=JSON.parse(this.$decrypt(res.data)).data
			// 	this.driverList = res.data
			// })
			// this.$api.fcarsList(this.$encrypt({})).then(res => { //车辆
			// 	res.data=JSON.parse(this.$decrypt(res.data)).data
			// 	this.arsList = res.data
			// })
			this.WarehouseLis('');
            this.getStateOfGoodsListI();
            this.districtFocus('');

			this.$api.findPmsUnit({}).then(res => { //单位
				this.unitList = res.data.list
            })
            
			this.$api.orderlist({
				position: '入库单'
			}).then(res => {
                // console.log('入库单---', res.data)
				this.typeList = res.data
            })
            
			this.$api.findcusomer(this.$encrypt({})).then(res => { //客户
				res.data=JSON.parse(this.$decrypt(res.data)).data
				this.userList = res.data
			})
			
			// this.$api.findrouteList({}).then(res => { //路线
			// 	this.routeList = res.data
			// })
			
			
			// console.log('2334--', moment().format("YYYY-MM-DD HH:mm:ss"))
		}
	}
</script>

<style>
	/* 新建的项目  去一下默认样式 */
	body,
	html {
		padding: 0;
		margin: 0;
	}
</style>
<style leng="less" scoped>
	.styleTable{
		/* background-color: skyblue !important; */
		border-left: 1px solid #e2e2e2 !important;
	}
	.container {
		position: relative;
	}

	.detail {
		background: rgb(244, 249, 254);
		width: 880px;
		height: 60px;
		border-radius: 5px;
		padding: 10px;
		line-height: 30px;
		font-size: 14px;
		display: flex;
		justify-content: space-between;
	}

	.detaildt {
		/* width: 1380px; */
		width: 93%;
		margin: 50px;
		overflow: hidden;
		background: white;
		height: auto;
		border-radius: 10px;
	}
	/deep/.el-select-dropdown,.el-popper{
		width: 800px;
		padding: 0 20px;
	}
	/* /deep/input[disabled],input:disabled,input.disabled{
		-webkit-text-fill-color:#C0C4CC;
		background: #e2e2e2;
		-webkit-opacity:1;
		opacity: 1;
		cursor: not-allowed;
	} */
	/deep/ .el-input.is-disabled .el-input__inner {
		background-color: #fdfbfb;
		border-color: #E4E7ED;
		color: #8a8a8b;
		cursor: not-allowed;
	}

	.printBox{
		display: none;
	}
</style>

<style media="print" lang="less">
	.content{
		table {
			font-family: Arial, sans-serif;
			font-size: 14px;
			background-color: #f0f2f5;
			border-collapse: collapse;
			color: #454545;
			table-layout: auto;
			width: 100%;
			text-align: center;
			border-bottom-width: 1px;
			border-bottom-style: solid;
			border-bottom-color: #dadcde;
			thead {
				border-top-width: 1px;
				border-top-style: solid;
				border-top-color: #dadcde;
				line-height: 40px;
				font-weight: bold;
				color: #454c70;
			}
			tr {
				border-top-width: 1px;
				border-top-style: solid;
				border-top-color: #dadcde;
				line-height: 23px;
			}
			td{
				padding: 5px 10px;
				font-size: 14px;
				font-family: Verdana;
				width: 100px;
				word-break: break-all; // 元素换行
			}
			// 斑马纹效果stripe
			tr:nth-child(even) {
				background: #F5F7F9;
			}
			tr:nth-child(odd) {
				background: #FFF;
			}
		}

	}
   @page {
       size:  241mm 159.5mm !important;
   	margin: 0 !important;
   }

    @media print {
		.printBox{
			display: block;
		}
        html {
            background-color: #ffffff;
            height: auto;
            margin: 0px;
            zoom: 89%;
        }
        // .content {
        //     transform: scale(0.95); /* 设置缩放比例 */
        //     transform-origin: top left; /* 确保从左上角开始缩放 */
        // }
        body {
            border: solid 1px #ffffff;
            // margin: 10mm 15mm 10mm 15mm;
            margin: 0 !important;
            padding: 0 !important;
        }
        /deep/ table {
            table-layout: auto !important;
        }
        /deep/ #pagetable table{
            table-layout: fixed !important;
        }
        .el-table__header-wrapper .el-table__header {
            width: 100% !important;
            border: solid 1px #f2f2f2;
        }
        .el-table__body-wrapper .el-table__body {
            width: 100% !important;
        }
        #pagetable table {
            table-layout: fixed !important;
		}
		.print-footer{
			position: absolute;
			bottom: 10vh;
			left: 0;
			width: 100%;
			display: flex;
		}
	}
	.client-name{
		text-align: center;
	}
</style>
